import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './assets/scss/style.scss'
import './index.css'
import './i18n'

const CHUNK_RELOAD_KEY = 'filtermarket_chunk_reload'
const isChunkFailure = (value) => /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(String(value || ''))
const recoverFromChunkFailure = (value) => {
  if (!isChunkFailure(value) || sessionStorage.getItem(CHUNK_RELOAD_KEY)) return
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  window.location.reload()
}

window.addEventListener('error', (event) => recoverFromChunkFailure(event?.message || event?.error?.message))
window.addEventListener('unhandledrejection', (event) => recoverFromChunkFailure(event?.reason?.message || event?.reason))
window.addEventListener('load', () => window.setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), 5000))
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
